import TreeSelect from './_tree-select';

export default TreeSelect;
